import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'

export const useEmbedDashboard = (embedUrl: string | null) => {
  const setDashboardRef = async (dashboardElement: HTMLDivElement | null) => {
    if (embedUrl && dashboardElement) {
      const embeddingContext = await createEmbeddingContext()
      const { embedDashboard } = embeddingContext

      const frameOptions = {
        url: embedUrl,
        container: dashboardElement,
        scrolling: 'no',
        height: '100%',
        width: '100%',
      }

      await embedDashboard(frameOptions)
    }
  }

  return setDashboardRef
}
